import axios from "../../axiosInstance";

const Item_base_api = "/rport/import"
class ImpReport {

    generateBExbondfile(details){
        return axios.post(Item_base_api+'/generateBExbondfile',details);
    }
    generateAmendmentBEfile(details){
        return axios.post(Item_base_api+'/generateAmendmentBEfile',details);
    }
    generateBEfile(details){
        return axios.post(Item_base_api+'/generateBEfile',details);
    }
    generateBeChecklist(details){
        return axios.post(Item_base_api+'/generateBeChecklist',details);
    }

}
export default new ImpReport();